module.exports = __webpack_public_path__ + "img/our_advantages.61973b57.png";